import { container } from "assets/jss/material-kit-react.jsx";

const componentsStyle = {
  container,
  brand: {
    color: "#000",
    textAlign: "center",
    },
  cardHidden: {
    opacity: "-0.9",
    transform: "skewX(25deg)"
  },
  title: {
    fontSize: "2.8rem",
    paddingLeft: "80px",
    fontWeight: "600",
    display: "inline-block",
    position: "relative",
  },
  subtitle: {
    paddingLeft: "10px",
    fontSize: "1.513rem",
    maxWidth: "100%",
    margin: "8px 0 0"
  },
   description: {
    color: 'black',
    overflow: "hidden",
    marginTop: "0px",
    fontSize: "19px",
    fontWeight: "600",
    backgroundColor :"000"
  },
  main: {
    background: "#fff",
    
  },
  iconStyle:{
    fontSize: '24px',
    paddingLeft: '2px',
    paddingRight: '5px',
  },
  mainRaised: {
    margin: "-60px 20px 0px",
    
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  link: {
    textDecoration: "none"
  },
  textCenter: {
    textAlign: "center"
  }
};

export default componentsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/components.jsx